'use client'

import { useEffect } from 'react'

import 'vanilla-cookieconsent/dist/cookieconsent.css'

import * as CookieConsent from 'vanilla-cookieconsent'

export default function CookieBanner({ isMobileWebview }: { isMobileWebview: boolean }) {
  useEffect(() => {

    if (isMobileWebview) return

    /**
     * All config. options available here:
     * https://cookieconsent.orestbida.com/reference/configuration-reference.html
     */
    CookieConsent.run({
      categories: {
        necessary: {
          enabled: true, // cette catégorie est activée par défaut
          readOnly: true, // cette catégorie ne peut pas être désactivée
        },
        analytics: {},
      },

      language: {
        default: 'fr',
        translations: {
          fr: {
            consentModal: {
              title: 'Nous utilisons des cookies !',
              description:
                'Nous utilisons des cookies pour améliorer votre expérience utilisateur. Vous pouvez gérer vos préférences ci-dessous.',
              acceptAllBtn: 'Accepter tout',
              acceptNecessaryBtn: 'Refuser tout',
              showPreferencesBtn: 'Gérer les préférences',
            },
            preferencesModal: {
              title: 'Gérer les préférences individuellement',
              acceptAllBtn: 'Accepter tout',
              acceptNecessaryBtn: 'Refuser tout',
              savePreferencesBtn: 'Accepter la sélection actuelle',
              closeIconLabel: 'Fermer la fenêtre',
              sections: [
                {
                  title: "Quelqu'un a dit ... cookies ?",
                  description: "J'en veux un !",
                },
                {
                  title: 'Cookies strictement nécessaires',
                  description:
                    'Ces cookies sont essentiels au bon fonctionnement du site web et ne peuvent pas être désactivés.',

                  // ce champ générera un bouton bascule lié à la catégorie 'necessary'
                  linkedCategory: 'necessary',
                },
                {
                  title: 'Performance et Analytique',
                  description:
                    'Ces cookies collectent des informations sur la façon dont vous utilisez notre site web. Toutes les données sont anonymisées et ne peuvent pas être utilisées pour vous identifier.',
                  linkedCategory: 'analytics',
                },
                {
                  title: "Plus d'informations",
                  description:
                    'Pour toute question concernant ma politique sur les cookies et vos choix, veuillez <a href="#contact-page">nous contacter</a>',
                },
              ],
            },
          },
        },
      },
    })
  }, [])

  return <></>
}
